module.exports = __webpack_public_path__ + "static/media/cases_3d_06e.1598bb5e.jpg";